import {
  TransactionCategory,
  TransactionType,
  PaymentMethod,
  transactionExpenseCategories,
  transactionIncomeCategories,
} from '@inversor-hub/types';

export const transactionTypeLabels: Record<TransactionType, string> = {
  EXPENSE: 'Gasto',
  INCOME: 'Ingreso',
};

export const transactionCategoryLabels: Record<TransactionCategory, string> = {
  RENTAL_INCOME: 'Alquiler cobrado',
  TENANT_RECHARGES_INCOME: 'Gastos repercutidos al inquilino',
  DEPOSIT_WITHHELD: 'Fianza retenida',
  SALE_INCOME: 'Venta del inmueble',
  OTHER_INCOME: 'Otros ingresos',
  FINANCING_INTEREST: 'Intereses de hipoteca/préstamo',
  LOAN_PRINCIPAL: 'Devolución de principal del préstamo',
  REPAIRS_MAINTENANCE: 'Conservación y reparación',
  IMPROVEMENT: 'Mejora o reforma',
  LOCAL_TAXES: 'IBI y tasas municipales',
  COMMUNITY_FEES: 'Comunidad',
  UTILITIES: 'Suministros',
  INSURANCE: 'Seguros',
  PROFESSIONAL_SERVICES: 'Gestoría / asesoría / abogado',
  LEGAL_DEFENSE: 'Defensa jurídica',
  RENTAL_MANAGEMENT: 'Gestión del alquiler',
  CLEANING: 'Limpieza',
  BAD_DEBT: 'Impago / dudoso cobro',
  DEPRECIATION_PROPERTY: 'Amortización del inmueble',
  DEPRECIATION_FURNITURE: 'Amortización de mobiliario y enseres',
  ACQUISITION_COSTS: 'Compra / gastos de adquisición',
  SALE_COSTS: 'Gastos de venta / transmisión',
  OTHER_DEDUCTIBLE_EXPENSE: 'Otros gastos deducibles',
  NON_DEDUCTIBLE_EXPENSE: 'No deducible',
  REVIEW: 'Revisar',
};

export const paymentMethodLabels: Record<PaymentMethod, string> = {
  CASH: 'Efectivo',
  BANK_TRANSFER: 'Transferencia',
  DIRECT_DEBIT: 'Domiciliación bancaria',
  CARD: 'Tarjeta',
};

export const expenseCategories: readonly TransactionCategory[] = transactionExpenseCategories;

export const incomeCategories: readonly TransactionCategory[] = transactionIncomeCategories;
